import _ from 'lodash';

import { AssignTaskBorrowerTargetEnum } from 'constants/loanActionEditor';
import {
  eachBorrowerEATOptions,
  entityAssignmentTypes,
  primaryBorrowerEATOptions,
  selectedBorrowersEATOptions,
} from 'constants/options';
import { DataType, EntityAssignmentType } from 'constants/taskCategories';
import { TaskAssignmentType } from 'constants/tasks';

import {
  ALL_BORROWERS_HELPER_TEXT,
  assignTaskBorrowerTargetOptions,
  SELECTED_BORROWERS_HELPER_TEXT,
} from './LoanActionTaskRow.constants';

const BORROWER_ONLY_DATA_TYPES = [
  DataType.FORMS,
  DataType.PAYMENT,
  DataType.INTERNAL_ACTION,
  DataType.DOCUMENT_REVIEW,
];

const isBorrowerOnlyDataType = dataType => BORROWER_ONLY_DATA_TYPES.includes(dataType);

const isAllBorrowersTarget = borrowerTargets =>
  _.some(borrowerTargets, { value: AssignTaskBorrowerTargetEnum.ALL_BORROWERS });

// Borrower 1 alone is the primary borrower, which is what a step without borrower targets already does.
const isPrimaryOnlyTarget = borrowerTargets =>
  _.isEmpty(borrowerTargets) ||
  (borrowerTargets.length === 1 &&
    borrowerTargets[0].value === AssignTaskBorrowerTargetEnum.BORROWER_1);

// Mirrors Skynet.Loans: only a borrower-assigned task type with a Borrower (or no) entity assignment
// type is borrower-scoped, so only it can be assigned to each borrower.
export const isBorrowerScopedTaskType = taskType =>
  taskType?.taskAssignmentType === TaskAssignmentType.BORROWER &&
  (_.isNil(taskType.entityAssignmentType) ||
    taskType.entityAssignmentType === EntityAssignmentType.BORROWER);

export const getAssignTaskEntityAssignmentTypeOption = (taskType, borrowerTargets) => {
  if (!isBorrowerOnlyDataType(taskType?.dataType)) {
    return entityAssignmentTypes.find(({ value }) => value === taskType?.entityAssignmentType);
  }

  if (isAllBorrowersTarget(borrowerTargets)) {
    return eachBorrowerEATOptions[0];
  }

  return isPrimaryOnlyTarget(borrowerTargets)
    ? primaryBorrowerEATOptions[0]
    : selectedBorrowersEATOptions[0];
};

export const getAssignTaskBorrowerTargetsHelperText = borrowerTargets => {
  if (isAllBorrowersTarget(borrowerTargets)) {
    return ALL_BORROWERS_HELPER_TEXT;
  }

  return isPrimaryOnlyTarget(borrowerTargets) ? null : SELECTED_BORROWERS_HELPER_TEXT;
};

export const getAssignTaskBorrowerTargetsFormFormat = (taskType, borrowerTargets) => {
  if (!isBorrowerScopedTaskType(taskType)) {
    return [];
  }

  return assignTaskBorrowerTargetOptions.filter(({ value }) => _.includes(borrowerTargets, value));
};

export const getAssignTaskBorrowerTargetsApiFormat = ({ taskType, borrowerTargets }) => {
  if (!isBorrowerScopedTaskType(taskType) || isPrimaryOnlyTarget(borrowerTargets)) {
    return null;
  }

  return isAllBorrowersTarget(borrowerTargets)
    ? [AssignTaskBorrowerTargetEnum.ALL_BORROWERS]
    : borrowerTargets.map(({ value }) => value);
};
